// extracted by mini-css-extract-plugin
export default {"BirthDateInput":"bfx_a bih_z bih_kc bih_qx bih_xc bih_eg","BirthDateInput--disabled":"bfx_b bih_fo"};